import React from 'react';
import { BellIcon, UserIcon, SearchIcon } from 'lucide-react';
interface HeaderProps {
  activeModule: string;
}
export const Header = ({
  activeModule
}: HeaderProps) => {
  const getModuleTitle = () => {
    switch (activeModule) {
      case 'leadscout':
        return 'LeadScout';
      case 'smartreach':
        return 'SmartReach';
      case 'referrocket':
        return 'ReferRocket';
      case 'conversai':
        return 'ConversAI';
      default:
        return 'Dashboard';
    }
  };
  const getModuleDescription = () => {
    switch (activeModule) {
      case 'leadscout':
        return 'Intelligente Zielkunden-Profilerstellung';
      case 'smartreach':
        return 'Personalisiertes Outreach & Kampagnenmanagement';
      case 'referrocket':
        return 'Empfehlungsmarketing & Kundenwerben-Kunden';
      case 'conversai':
        return 'KI-gestützte Automatisierung & Chatbot-Flows';
      default:
        return 'Integrierte B2B Go-to-Market Plattform';
    }
  };
  return <header className="bg-white border-b border-gray-200 px-6 py-4" data-id="element-63">
      <div className="flex items-center justify-between" data-id="element-64">
        <div data-id="element-65">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-66">
            {getModuleTitle()}
          </h1>
          <p className="text-sm text-gray-500" data-id="element-67">{getModuleDescription()}</p>
        </div>
        <div className="flex items-center space-x-4" data-id="element-68">
          <div className="relative" data-id="element-69">
            <input type="text" placeholder="Suchen..." className="pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-70" />
            <SearchIcon size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-71" />
          </div>
          <button className="p-2 rounded-full hover:bg-gray-100 relative" data-id="element-72">
            <BellIcon size={20} className="text-gray-600" data-id="element-73" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" data-id="element-74"></span>
          </button>
          <div className="flex items-center space-x-2" data-id="element-75">
            <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center" data-id="element-76">
              <UserIcon size={16} className="text-white" data-id="element-77" />
            </div>
            <span className="text-sm font-medium text-gray-700" data-id="element-78">Admin</span>
          </div>
        </div>
      </div>
    </header>;
};